<div *ngIf="!wind.calm; else calm" class="wind__container">
  <span class="wind__direction">
    <app-bearing *ngIf="wind.direction" [bearing]="wind.direction" [color]="'#537171'" class="wind__direction-indicator"></app-bearing>
    <span *ngIf="wind.vrb" class="wind__direction-value">VRB</span>
    <span *ngIf="!wind.vrb" class="wind__direction-value">{{ direction }}&deg;</span>
  </span>
  <div class="wind__speed-container">
    <span class="wind__sep">@</span>
    <span class="wind__speed" [innerHTML]="wind.speed"></span>
    <span *ngIf="wind.gust" class="wind__sep">G</span>
    <span *ngIf="wind.gust" class="wind__gust" [innerHTML]="wind.gust"></span>
    <span class="wind__unit wind__suffix">KT</span>
  </div>
</div>
<ng-template #calm>CALM</ng-template>
